const initBbHomeReviews = (root) => {
  root.querySelectorAll('[data-bb-home-reviews]').forEach((section) => {
    const toggle = section.querySelector('[data-bb-reviews-toggle]');
    const label = section.querySelector('[data-bb-reviews-toggle-label]');
    if (!toggle || !label || toggle.dataset.bbReviewsReady) return;

    toggle.dataset.bbReviewsReady = 'true';
    toggle.addEventListener('click', () => {
      const paused = section.toggleAttribute('data-paused');
      toggle.setAttribute('aria-pressed', String(paused));
      label.textContent = paused ? 'Beweging hervatten' : 'Beweging pauzeren';
    });
  });
};

initBbHomeReviews(document);
document.addEventListener('shopify:section:load', (event) => initBbHomeReviews(event.target));
